import { useCallback, isValidElement, Children } from 'react';
import { MultiSelectOption } from '../../../next/components/MultiSelect/MultiSelectOption.js';
import { OptionGroup } from '../../OptionGroup/OptionGroup.js';
import { Option } from '../../Option/Option.js';

function useUtils() {
  /**
   * DropdownOptionList is a component created to work along with:
   * - Option
   * - OptionGroup
   * - MultiSelectOption
   */
  const isValidOptionElement = useCallback(element => {
    return element.type === Option || element.type === OptionGroup || element.type === MultiSelectOption;
  }, []);
  const hasChildren = useCallback(element => {
    return /*#__PURE__*/isValidElement(element) && Boolean(element.props.children);
  }, []);
  const hasComplexOptionsChildren = useCallback(element => {
    return /*#__PURE__*/isValidElement(element) && hasChildren(element) && Children.toArray(element.props.children).reduce((_current, child) => /*#__PURE__*/isValidElement(child) && isValidOptionElement(child), false);
  }, [hasChildren, isValidOptionElement]);
  const getValueString = useCallback(value => {
    return typeof value === 'string' ? value : value.value;
  }, []);
  return {
    getValueString,
    hasComplexOptionsChildren,
    isValidOptionElement
  };
}

export { useUtils };
//# sourceMappingURL=useUtils.js.map
